import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";
const PhoneFieldComponent = (props) => {
  let {
    required = false,
    disabled,
    initialValue,
    name,
    checkEmail = false,
  } = props;

  if (name === undefined) {
    name = "mobile";
  }

  const isValid = (tel, allValues) => {
    const re = /^[0-9*.*]{10,15}$/;

    const isRequired =
      (checkEmail && !allValues.pitRegEmailAddress) || required;

    if (tel != null && tel !== "") {
      return (tel || !isRequired) &&
        (re.test(tel) ||
          (!isRequired && (tel === undefined || tel?.length === 0)))
        ? undefined
        : "Enter a valid mobile number";
    }

    return isRequired ? "Mobile number is required" : undefined;
  };

  return (
    <Field
      name={name}
      required={required}
      validate={isValid}
      label="Mobile Number"
      initialValue={initialValue}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      disabled={disabled}
      fullWidth
      inputProps={{ maxLength: 15 }}
    />
  );
};

export default PhoneFieldComponent;
